<div class="common-alert-box animate fade-in" [ngClass]="type">
    <ng-content select="[content]"></ng-content>
</div>